import angular from 'angular'
import './mini_game_configurations.service'
import './edit/edit.controller'

angular
  .module('admin.mini_game_configurations', [
    'admin.mini_game_configurations.service',
    'admin.mini_game_configurations.edit',
  ])
  .controller('MiniGameConfigurationsCtrl', MiniGameConfigurationsCtrl)

/** @ngInject */
function MiniGameConfigurationsCtrl(
  $scope,
  $q,
  $state,
  $timeout,
  $stateParams,
  MiniGameConfigurationsService,
) {
  var vm = this
  vm.items = []

  vm.perPage = 25

  function reloadPaginationDraft() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPaginationPublish() {
    vm.totalItems2 = 0
    vm.oldPage2 = 0
    vm.currentPage2 = 25
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  function reloadPaginationArchived() {
    vm.totalItems3 = 0
    vm.oldPage3 = 0
    vm.currentPage3 = 25
    vm.first3 = true
    vm.totalItems3 = 0
    vm.pagination3 = {
      current: 1,
    }
  }

  reloadPaginationDraft()
  reloadPaginationPublish()
  reloadPaginationArchived()
  loadPublished(1)
  loadUnpublished(1)
  loadArchived(1)

  var tab = localStorage.getItem('mini_game_configurations')
  if (tab !== null) {
    if (tab === 'draft') {
      $('#published').removeClass('active')
      $('#archived').removeClass('active')
      $('#draft').addClass('active')
      $('#drafttab').addClass('active')
    } else if (tab === 'published') {
      $('#draft').removeClass('active')
      $('#archived').removeClass('active')
      $('#published').addClass('active')
      $('#publishedtab').addClass('active')
    } else {
      $('#draft').removeClass('active')
      $('#published').removeClass('active')
      $('#archived').addClass('active')
      $('#archivedtab').addClass('active')
    }
  } else {
    $('#draft').addClass('active')
    $('#drafttab').addClass('active')
  }

  vm.tabDraft = function () {
    $('#published').removeClass('active')
    $('#archived').removeClass('active')
    $('#draft').addClass('active')
    localStorage.setItem('mini_game_configurations', 'draft')
  }

  vm.tabPublished = function () {
    $('#draft').removeClass('active')
    $('#archived').removeClass('active')
    $('#published').addClass('active')
    localStorage.setItem('mini_game_configurations', 'published')
  }

  vm.tabArchived = function () {
    $('#draft').removeClass('active')
    $('#published').removeClass('active')
    $('#archived').addClass('active')
    localStorage.setItem('mini_game_configurations', 'archived')
  }

  function loadUnpublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    MiniGameConfigurationsService.listUnpublish(vm.oldPage, 25).then(function (result) {
      var offers = result.results
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      vm.itemsDraft = offers
    })
  }

  function loadPublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first) {
      vm.currentPage2 = pageNumber * 25
      vm.oldPage2 = vm.currentPage2 - 25
    } else {
      vm.first2 = false
    }

    MiniGameConfigurationsService.listPublish(vm.oldPage2, 25).then(function (result) {
      var offers = result.results
      if (vm.totalItems2 === 0) {
        vm.totalItems2 = result.ct
      }
      vm.itemsPublish = offers
    })
  }

  function loadArchived(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination3.current = 1
    }
    if (!vm.first) {
      vm.currentPage3 = pageNumber * 25
      vm.oldPage3 = vm.currentPage3 - 25
    } else {
      vm.first3 = false
    }

    MiniGameConfigurationsService.listArchived(vm.oldPage3, 25).then(function (result) {
      var offers = result.results
      if (vm.totalItems3 === 0) {
        vm.totalItems3 = result.ct
      }
      vm.itemsArchived = offers
    })
  }

  vm.pageChanged = function (newPage) {
    vm.sortType = oldSortType
    loadUnpublished(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChanged2 = function (newPage) {
    vm.sortType2 = oldSortType2
    loadPublished(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChanged3 = function (newPage) {
    vm.sortType3 = oldSortType3
    loadArchived(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.add = function () {
    $state.go('admin.mini_game_configurations.edit', { id: 0 })
  }

  vm.delete = function (item) {
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          MiniGameConfigurationsService.remove(item.id).then(
            function () {
              if (vm.itemsDraft.length === 1 || vm.itemsDraft.length === 25) {
                $state.reload()
              } else {
                loadUnpublished(vm.pagination.current)
              }
              if (vm.itemsPublish.length === 1 || vm.itemsPublish.length === 25) {
                $state.reload()
              } else {
                loadPublished(vm.pagination2.current)
              }
              if (vm.itemsArchived.length === 1 || vm.itemsArchived.length === 25) {
                $state.reload()
              } else {
                loadArchived(vm.pagination3.current)
              }
            },
            function () {
              $timeout(function () {
                swal("You can't delete because has things associated with it", '', 'error')
              }, 750)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.unpublish = function (item) {
    MiniGameConfigurationsService.unpublish(item.id).then(function () {
      reloadPaginationDraft()
      reloadPaginationPublish()
      loadUnpublished(1)
      loadPublished(1)
    })
  }

  vm.back = function () {
    loadUnpublished(1)
    loadPublished(1)
    loadArchived(1)
  }
}
